// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Kfc1Y","activeWrapper":"styles_activeWrapper__y+POM","text":"styles_text__T-bwl","activeText":"styles_activeText__Dub8Z"};